<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="!isTestemunho">{{'Pessoas orando por você' | translate}}</ion-title>
    <ion-title *ngIf="isTestemunho">{{'Pessoas deram ' | translate}} {{'amem' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div class="list-mini">
    <ion-list *ngFor="let a of pessoas;" class="remove-border">
      <ion-item>
        <ion-avatar slot="start">
          <img src="{{a.foto | image:' '}}" />
        </ion-avatar>

        <ion-label>
          <h3>{{a.nome}}</h3>
        </ion-label>
      </ion-item>
    </ion-list>

    <sem-registro [hidden]="pessoas.length"></sem-registro>
  </div>
</ion-content>